import { c as _c } from "react/compiler-runtime";
import { Details, Summary } from '@/components/Atoms/Details/Details';
import { Prose } from '@/components/Atoms/Prose/Prose';
import type { INewsStory } from '@/components/Pages/News/NewsRsfPage';
import { useStoredState } from '@/hooks/useStoredState';
import { trackEvent } from '@/services/Analytics/BBAnalytics';
import { TrackingAction, TrackingCategory } from '@/services/Analytics/bnefAnalyticsSettings';
import AiGenerativeFillIcon from '@bloomberg/web-icons-react/AiGenerativeFill';
import type { FC } from 'react';
import styles from './NewsAiSummary.module.css';
export const NewsAiSummary: FC<{
  aiSummary: INewsStory['aiSummary'];
}> = t0 => {
  const $ = _c(14);
  const {
    aiSummary
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["ai", "summary", "open"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [isOpen, setIsOpen] = useStoredState(t1, true);
  if (!(aiSummary?.text?.length > 0)) {
    return null;
  }
  let t2;
  let t3;
  if ($[1] !== setIsOpen) {
    t2 = () => {
      trackEvent(TrackingAction.Open, TrackingCategory.AiSummary);
      setIsOpen(true);
    };
    t3 = () => {
      trackEvent(TrackingAction.Close, TrackingCategory.AiSummary);
      setIsOpen(false);
    };
    $[1] = setIsOpen;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Summary className="cds-t-h4"><span className={styles.title}><span>Summary <span className="cds-t-body">by Bloomberg AI</span></span><AiGenerativeFillIcon /></span></Summary>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== aiSummary.text) {
    t5 = aiSummary.text.map(_temp);
    $[5] = aiSummary.text;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <Prose><ul>{t5}</ul></Prose>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isOpen || $[10] !== t2 || $[11] !== t3 || $[12] !== t6) {
    t7 = <Details open={isOpen} onOpened={t2} onClosed={t3} className={styles.details}>{t4}{t6}</Details>;
    $[9] = isOpen;
    $[10] = t2;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
function _temp(item, index) {
  return <li key={`ai-summary-${index}`}>{item}</li>;
}